export interface FinancialPrimaryPayerConflict {
  id: string;
  payerName: string;
  effectiveFrom: string;
  effectiveUntil: string | null;
}

export class FinancialPrimaryPayerConflictError extends Error {
  constructor(public readonly conflicts: FinancialPrimaryPayerConflict[]) {
    super('Já existe pagador principal com vigência sobreposta. Confirme se deseja substituí-lo.');
    this.name = 'FinancialPrimaryPayerConflictError';
  }
}

export function parseFinancialPrimaryPayerConflict(details: string | null | undefined): FinancialPrimaryPayerConflict[] | null {
  try {
    const parsed: unknown = JSON.parse(details ?? '');
    if (!parsed || typeof parsed !== 'object' || !('conflicts' in parsed)) return null;
    const conflicts = parsed.conflicts;
    if (!Array.isArray(conflicts) || !conflicts.length) return null;
    if (!conflicts.every((row: unknown) => row !== null && typeof row === 'object'
      && 'id' in row && typeof row.id === 'string' && row.id.length > 0
      && 'payerName' in row && typeof row.payerName === 'string'
      && 'effectiveFrom' in row && typeof row.effectiveFrom === 'string'
      && 'effectiveUntil' in row && (row.effectiveUntil === null || typeof row.effectiveUntil === 'string'))) return null;
    return conflicts as FinancialPrimaryPayerConflict[];
  } catch {
    return null;
  }
}
